/**
 * @ComponentFor Avensia.Shop.Features.Search.Pages.Search.Components.SearchPageHeader
 */
import React from "react";
import { translate } from "Shared/translate";
import * as styles from "./components.scss";
import { searchPageUrl } from "Shared/known-urls";
import SearchPageInfoBlock from "./SearchPageInfoBlock";
import classnames from "classnames";
import SearchQuickFilters from "./SearchQuickFilters";
import { getQueryStringParameterByName } from "../../../../MyMenigo/Blocks/DeliveryBlock/Components/action-creators";
import { conceptFilterParameterName } from "Shared/Facet/ConceptFacet";
import MyMenigoIcon from "../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import * as categorystyles from "../../../../Category/Commerce/base.scss";
const SearchPageHeader = (props) => {
    const getConceptBreadCrumbItem = (onlyItem) => {
        const activeConcept = !!props.activeConcept &&
            getQueryStringParameterByName(conceptFilterParameterName);
        if (!activeConcept)
            return React.createElement(React.Fragment, null);
        if (onlyItem)
            return (React.createElement("li", { key: "conceptBreadcrumb", className: classnames(categorystyles.backToConcept, styles.clearAfter) },
                React.createElement(MyMenigoIcon, { name: "arrow" }),
                React.createElement("a", { className: categorystyles.link, href: props.activeConcept.conceptUrl }, props.activeConcept.displayName)));
        else
            return (React.createElement("ul", { className: classnames(categorystyles.categoryList, categorystyles.breadcrumbsList) }, getConceptBreadCrumbItem(true)));
    };
    return (React.createElement("div", { className: classnames(styles.searchSuggestionBackgroundBox, {
            [styles.hasSuggestion]: !(props.products.totalProductCount > 0 || !!props.hasContent) &&
                props.searchSuggestions.length > 0,
            [styles.hasFilters]: props.products.totalProductCount > 0 || !!props.hasContent,
        }) },
        React.createElement("div", { className: styles.searchSuggestionBox },
            getConceptBreadCrumbItem(false),
            React.createElement("h1", { className: styles.header },
                translate("/Search/ResultsFor", ""),
                " ",
                React.createElement("strong", null,
                    "\u201C",
                    props.searchPhrase,
                    "\u201D")),
            (props.products.totalProductCount > 0 || !!props.hasContent) && (React.createElement(SearchQuickFilters, { quickFilterBlocks: props.page.quickFiltersArea, products: props.products })),
            !(props.products.totalProductCount > 0 || !!props.hasContent) &&
                props.searchSuggestions.length > 0 && (React.createElement("div", { className: styles.searchSuggestion },
                " ",
                React.createElement("ul", null,
                    React.createElement("li", { key: "text" },
                        translate("/Shared/FadeNoHits"),
                        ` ${translate("/Search/DidYouMean")}:`),
                    props.searchSuggestions.map((suggestion, i) => (React.createElement("li", { key: suggestion.text },
                        React.createElement("a", { className: styles.button, "data-ticket": suggestion.ticket, href: searchPageUrl().url + "?q=" + suggestion.text }, suggestion.text))))))),
            !(props.products.totalProductCount > 0 || !!props.hasContent) &&
                props.searchSuggestions.length < 1 && (React.createElement("div", null, translate("/Shared/FadeNoHits")))),
        !(props.products.totalProductCount > 0 || !!props.hasContent) && (React.createElement(SearchPageInfoBlock, { helpText: props.page.helpText, helpTextChat: props.page.helpTextChat }))));
};
export default SearchPageHeader;
